

























import { Vue, Component, Prop } from "vue-property-decorator";
import { OrgFeatureKeys } from "@/data/constants";

@Component
export default class UpmindUpgradeMessage extends Vue {
  // Props

  @Prop({ default: "" })
  public feature!: string;

  @Prop({ default: null })
  public featureKey!: OrgFeatureKeys;

  @Prop({ default: 0 })
  public total!: number;

  // Computed

  public get featureLabel() {
    if (this.feature) return this.feature;
    switch (this.featureKey) {
      case OrgFeatureKeys.UNLIMITED_PAYMENT_GATEWAYS:
        return this.$t("_.payment_gateways")
          .toString()
          .toLowerCase();
      case OrgFeatureKeys.UNLIMITED_PROVISION_CONFIGURATIONS:
        return this.$t("_.provision_configurations")
          .toString()
          .toLowerCase();
      default:
        return (this.featureKey || "").toLowerCase();
    }
  }

  public get limit() {
    return this.$store.getters["org/getPackageLimit"](this.featureKey);
  }

  public get showMessage() {
    if (!this.$store.getters["user/isUpmindClient"]) return false;
    return typeof this.limit === "number";
  }
}
